import { useNavigate } from "react-router-dom";
import Icon from "@/components/Icon";
import { colors, spacing, fonts, type, phoneColumn } from "@/theme";

// Centered mobile-width column used by the companion app screens.
export function Screen({ children, testID, maxWidth = 560, style }) {
  return (
    <div style={{ background: colors.surface, minHeight: "100vh" }}>
      <div style={{ ...phoneColumn, maxWidth, ...style }} data-testid={testID}>
        {children}
      </div>
    </div>
  );
}

// Back header with centered title.
export function Header({ title, onBack, testID }) {
  const navigate = useNavigate();
  const back = onBack || (() => navigate(-1));
  return (
    <div style={headerStyle}>
      <button data-testid={testID} onClick={back} style={sideStyle} className="ember-press" aria-label="Back">
        <Icon name="chevron-left" size={30} color={colors.onSurface} />
      </button>
      <span style={{ ...fonts.displaySemiBold, fontSize: type.xl, color: colors.onSurface }}>{title}</span>
      <div style={sideStyle} />
    </div>
  );
}

const headerStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: `${spacing.sm}px ${spacing.md}px`,
  borderBottom: `1px solid ${colors.divider}`,
};
const sideStyle = { width: 48, height: 48, display: "flex", alignItems: "center", justifyContent: "center" };
